import Vue from 'vue';
import router from '@this/router';
import store from '@this/store';
import App from '@this/App';

// 指令
import auth from '@blocks/auth/directive';

// 样式
import '@/styles/global.scss';
import '@this/styles/global.scss';

// 注册指令
Vue.directive('auth', auth);

// debug console mock
if (process.env.VUE_APP_ENV !== 'development') {
  const fundebug = require('fundebug-javascript');
  const { fundebugConfig, errorHandler } = require('@/utils/debug');
  const userInfo = store.state.user?.userInfo;
  fundebug.init(fundebugConfig);
  Vue.config.errorHandler = (error) => {
    errorHandler({ fundebug, error, extInfo: userInfo });
  };
}
if (process.env.VUE_APP_ENV !== 'production') {
  const vConsole = require('vconsole');
  new vConsole();
}
if (process.env.VUE_APP_ENV === 'development') {
  require('@this/mock');
}

// config
Vue.config.productionTip = false;

// 挂载Vue
window.Vue = Vue;
window.VueOptions = {
  router,
  store,
  render: (h) => h(App),
};
